// extracted by mini-css-extract-plugin
module.exports = {"main":"layout-module--main--25lS7","mainContent":"layout-module--mainContent--1LJ_b"};